import { getCurrentAuthState } from '~/atoms/AuthenticationState'
import { domains } from '~/constants/domains'

import { groveSchedulerClient } from '@mangovoice/grove-scheduler-client'

/**
 * Get auth data for grove-scheduler-client
 * Uses the same JWT access token as MangoApi
 */
const getAuthData = () => {
  const currentState = getCurrentAuthState()
  return {
    accessToken: currentState.appSessionJwts?.access_token ?? null,
  }
}

/**
 * Grove Scheduler API client instance
 * Proxied through mango-api at /internal/v1/integration-agents/
 * Uses the same base URL as MangoApi (api.mangovoice.com, api-staging.mangovoice.com, etc.)
 */
const baseUrl = domains.MANGO_API()
const apiInst: ReturnType<typeof groveSchedulerClient.create> =
  groveSchedulerClient.create(baseUrl)

apiInst.setCallbacks(getAuthData)

/**
 * Get the grove-scheduler-client instance
 */
export const getGroveSchedulerApiInst = () => apiInst

/**
 * Hook to access the grove-scheduler-client instance
 */
export const useGroveSchedulerApi = () => getGroveSchedulerApiInst()
